import {ELECTRICITY, WATER} from 'constants/enum/meterType'
import {CONSTANT, NAME_RATE} from 'constants/enum/nameRate'
import {useEffect, useMemo} from 'react'
import {resetSectionFields} from 'services/utils/formUtils'
import {useGetCurrentUserQuery} from 'store/Store'
import cloneDeep from 'lodash/cloneDeep'

const useFormRateLogic = ({fields, methods}) => {
    const {data: user} = useGetCurrentUserQuery()

    const {watch, resetField, setValue} = methods

    const {category, isGlobal, name} = watch()

    const controlledFields = useMemo(() => {
        const nextFields = cloneDeep(fields || {})
        const accountSection = nextFields.account || {}
        const rateSection = nextFields.rateSection || {}
        const dateAndTimeSection = nextFields.dateAndTimeSection || {}
        const settingsSection = nextFields.settingSection || {}
        const nameField = rateSection.items?.name

        if (category !== ELECTRICITY || !category) {
            nextFields.dateAndTimeSection = {
                ...dateAndTimeSection,
                hidden: true,
            }
            if (nameField) {
                nameField.options = [CONSTANT]
            }
        } else if (name !== CONSTANT && name) {
            nextFields.dateAndTimeSection = {
                ...dateAndTimeSection,
                hidden: false,
            }
            if (nameField) {
                nameField.options = NAME_RATE
            }
        } else if (nameField) {
            nameField.options = NAME_RATE
        }

        if (category === ELECTRICITY && name === CONSTANT) {
            nextFields.dateAndTimeSection = {
                ...nextFields.dateAndTimeSection,
                hidden: true,
            }
        }

        if (!user?.account && user?.isSuperUser) {
            nextFields.account = {
                ...accountSection,
                hidden: Boolean(isGlobal),
            }
            if (settingsSection.items?.isGlobal) {
                settingsSection.items = {
                    ...settingsSection.items,
                    isGlobal: {
                        ...settingsSection.items.isGlobal,
                        sm: isGlobal ? 12 : settingsSection.items.isGlobal.sm,
                    },
                }
            }
        } else {
            nextFields.account = {
                ...accountSection,
                hidden: false,
            }
        }

        nextFields.settingSection = {
            ...settingsSection,
            hidden: Boolean(user?.account),
        }

        return nextFields
    }, [fields, category, name, isGlobal, user])

    useEffect(() => {
        if (isGlobal) {
            const accountFieldName =
                controlledFields.account?.items?.account?.name ||
                fields?.account?.items?.account?.name
            if (accountFieldName) {
                setValue(accountFieldName, null)
            }
        }
    }, [isGlobal, controlledFields.account?.items?.account?.name, fields, setValue])

    useEffect(() => {
        if (category === WATER) {
            const nameFieldName =
                controlledFields.rateSection?.items?.name?.name ||
                fields?.rateSection?.items?.name?.name
            if (nameFieldName) {
                setValue(nameFieldName, CONSTANT)
            }
        }
    }, [category, controlledFields.rateSection?.items?.name?.name, fields, setValue])

    useEffect(() => {
        if (controlledFields.dateAndTimeSection?.hidden) {
            resetSectionFields(
                controlledFields.dateAndTimeSection?.items || fields?.dateAndTimeSection?.items,
                resetField
            )
        }
    }, [
        controlledFields.dateAndTimeSection?.hidden,
        controlledFields.dateAndTimeSection?.items,
        fields,
        resetField,
    ])

    useEffect(() => {
        if (controlledFields.settingSection?.hidden) {
            resetSectionFields(
                controlledFields.settingSection?.items || fields?.settingSection?.items,
                resetField
            )
        }
    }, [
        controlledFields.settingSection?.hidden,
        controlledFields.settingSection?.items,
        fields,
        resetField,
    ])

    return {fields: controlledFields}
}

export default useFormRateLogic
